export const MODULES = {
    SANCIONES: {
        name: "Módulo Disciplinario",
        path: "/conf-notificaciones/monitor/sanciones",
        code: "SANCIONES",
        responsibles: ["Encargado_Sanciones","Responsable_Sanciones"]
    },
    SELECCION_CONTRATACION: {
        name: "Selección y Contratación",
        path: "/conf-notificaciones/monitor/seleccion",
        code: "SELECCION_CONTRATACION",
        responsibles: ["Responsable_Seleccion_Contratacion"]
    },
    CLIMA: {
        name: "Clima",
        path: "/conf-notificaciones/monitor/clima",
        code: "CLIMA",
        responsibles: ["responsable"]
    },
    ONBOARDING: {
        name: "OnBoarding",
        path: "/conf-notificaciones/monitor/onboarding",
        code: "ONBOARDING",
        responsibles: ["Responsable_OnBoarding"]
    },
    OFFBOARDING: {
        name: "OffBoarding",
        path: "/conf-notificaciones/monitor/offboarding",
        code: "OFFBOARDING",
        responsibles: ["Responsable_OffBoarding"]
    },
    EVALUACION: {
        name: "Evaluación",
        path: "/conf-notificaciones/monitor/evaluacion",
        code: "EVALUACION",
        responsibles: ["Responsable_Evaluacion"]
    },
    DESEMPENIO: {
        name: "Desempeño",
        path: "/conf-notificaciones/monitor/desempeno",
        code: "DESEMPEÑO",
        responsibles: ["Responsable_Desempenio"]
    },
    DESCRIPTORES_PERFILES: {
        name: "Descriptores y Perfiles",
        path: "/conf-notificaciones/monitor/descriptores",
        code: "DESCRIPTORES_PERFILES",
        responsibles: ["Responsable_Descriptores_Perfiles"]
    },
    SUCESION: {
        name: "Sucesión",
        path: "/conf-notificaciones/monitor/sucesion",
        code: "SUCESION",
        responsibles: ["Responsable_Carrera_Sucesion"]
    },
    CARRERA: {
        name: "Carrera",
        path: "/conf-notificaciones/monitor/carrera",
        code: "CARRERA",
        responsibles: ["Responsable_Carrera"]
    },
    CAPACITACION: {
        name: "Capacitación",
        path: "/conf-notificaciones/monitor/capacitacion",
        code: "CAPACITACION",
        responsibles: ["Responsable_Capacitacion"]
    }
}

export const TIPO_ACCION_HISTORIAL = {
    CREACION: "creacion",
    ERROR: "error",
    CAMBIO_ESTADO: "cambio_estado",
    ENVIO: "envio"
}